import React from 'react';
import { CTAButton } from './CTAButton';
export function IncludedSection() {
  const books = [{
    emoji: '📘',
    title: '100 Citas Mamá e Hija',
    desc: 'Momentos uno a uno para hablar, reír y crear un vínculo que ella va a recordar toda su vida.',
    color: 'border-blue-500',
    bg: 'bg-blue-50'
  }, {
    emoji: '📗',
    title: '100 Citas Mamá e Hijo',
    desc: 'Actividades para conectar desde el juego, la escucha y el amor. Porque él también necesita esos momentos con vos.',
    color: 'border-green-500',
    bg: 'bg-green-50'
  }, {
    emoji: '📙',
    title: '100 Citas Papá e Hija',
    desc: 'Espacios únicos para reforzar seguridad, confianza y cercanía. Ella necesita saber que papá siempre está.',
    color: 'border-orange-500',
    bg: 'bg-orange-50'
  }, {
    emoji: '📕',
    title: '100 Citas Papá e Hijo',
    desc: 'Propuestas para compartir tiempo real y crear recuerdos que van a definir quién es él como persona.',
    color: 'border-red-500',
    bg: 'bg-red-50'
  }];
  return <section className="py-10 md:py-14 px-4 bg-white" data-id="element-87">
      <div className="max-w-3xl mx-auto" data-id="element-88">
        <div data-id="element-89">
          <div className="text-center mb-10" data-id="element-90">
            <h2 className="text-2xl md:text-4xl font-black text-gray-900 mb-3" data-id="element-91">
              📚 ESTO ES TODO LO QUE RECIBÍS HOY
            </h2>
            <p className="text-sm md:text-base text-gray-500 italic" data-id="element-92">
              Todo lo que necesitás para transformar la relación con tus hijos.
            </p>
            <div className="w-16 h-1.5 bg-red-600 mx-auto rounded-full mt-4" data-id="element-93"></div>
          </div>

          <div className="space-y-4 mb-10" data-id="element-94">
            {books.map((book, idx) => <div key={idx} className={`flex flex-col md:flex-row items-center md:items-start gap-4 p-4 rounded-xl border-2 ${book.color} ${book.bg} shadow-sm`} data-id="element-95">
                <div className="text-4xl md:text-5xl" data-id="element-96">{book.emoji}</div>
                <div className="text-center md:text-left flex-1" data-id="element-97">
                  <h3 className="text-xl font-black text-gray-900 mb-1" data-id="element-98">
                    {book.title}
                  </h3>
                  <p className="text-sm md:text-base text-gray-700 mb-3 font-medium" data-id="element-99">
                    {book.desc}
                  </p>
                  <p className="inline-block bg-white px-3 py-1 rounded-full text-xs font-bold text-gray-500 border border-gray-200 shadow-sm" data-id="element-100">
                    Valor estimado:{' '}
                    <span className="line-through" data-id="element-101">$10.000</span>
                  </p>
                </div>
              </div>)}
          </div>

          <div className="bg-yellow-50 border-2 border-yellow-400 p-4 rounded-xl text-center mb-8 shadow-sm" data-id="element-102">
            <p className="text-lg md:text-xl font-black text-gray-900" data-id="element-103">
              👉 Un solo pack.
              <br className="md:hidden" data-id="element-104" /> 👉 Todos los vínculos padres e hijos
              cubiertos.
            </p>
            <p className="text-xs md:text-sm text-gray-600 italic mt-2" data-id="element-105">
              Porque cada hijo merece momentos únicos con mamá y con papá.
            </p>
          </div>

          <CTAButton text="🔥 QUIERO ESTOS MOMENTOS CON MIS HIJOS" data-id="element-106" />
        </div>
      </div>
    </section>;
}